import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useState} from "react";
import {RouteHelper} from "../../../route/RouteHelper";
import {
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import PeriodBasicInfo from "./PeriodBasicInfo";
import ResidenceChoice from "./ResidenceChoice";
import RequestsList from "../../requestsList/RequestsList";
import ReserveList from "../../reserveList/ReserveList";

export default function PeriodDetails() {


    const {state} = useLocation();
    const {id: periodId = -1} = useParams();

    const [searchParams, setSearchParams] = useSearchParams()

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.PeriodList.name);
    const [tabSelectedValue, setTabSelectedValue] = useState(searchParams.get("tab")||PeriodTabType.BasicInformation.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
        navigate(`/panel/habitation/period-list/${periodId}?tab=${newValue}`)
    }

    const navigate = useNavigate()


    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Habitation.name,
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.PeriodList.name,
                                RouteHelper.PeriodList.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                pageTitle,
                                ""
                            ),
                        ]}
                    />
                    <RaikoButtonSecondary label={"بازگشت"} onClick={_ => {
                        navigate(-1)
                    }}/>
                </RaikoFlexFirstChildGrowOne>

                <TabContext value={tabSelectedValue}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                            <Tab
                                label={PeriodTabType.BasicInformation.title}
                                value={PeriodTabType.BasicInformation.id}/>

                            <Tab
                                label={PeriodTabType.ResidencesList.title}
                                value={PeriodTabType.ResidencesList.id}/>

                            <Tab
                                label={PeriodTabType.RequestsList.title}
                                value={PeriodTabType.RequestsList.id}/>
                            <Tab
                                label={PeriodTabType.ReserveList.title}
                                value={PeriodTabType.ReserveList.id}/>
                        </TabList>
                    </Box>
                    <TabPanel value={PeriodTabType.BasicInformation.id}>
                        <PeriodBasicInfo periodId={periodId}/>
                    </TabPanel>
                    <TabPanel value={PeriodTabType.ResidencesList.id}>
                        <ResidenceChoice periodId={periodId}/>
                    </TabPanel>
                    <TabPanel value={PeriodTabType.RequestsList.id}>
                        <RequestsList periodId={periodId}/>
                    </TabPanel>
                    <TabPanel value={PeriodTabType.ReserveList.id}>
                        <ReserveList periodId={periodId}/>
                    </TabPanel>
                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}
const PeriodTabType = {
    BasicInformation: {
        id: "basic-information",
        title: "اطلاعات پایه",
    },
    ResidencesList: {
        id: "residences-list",
        title: "اقامتگاه ها",
    },
    RequestsList: {
        id: "requests-list",
        title: "درخواست ها"
    },
    ReserveList: {
        id: "reserve-list",
        title: "اسکان ها"
    },
    RequestDetails: {
        id: "request-details",
        title: "جزئیات درخواست"
    },
    Rules: {
        id: "rules",
        title: "قوانین",
    },
}